<template>
	<div id="Store">
		<iframe id="iframe" :src="resuouce" v-if="resuouce"></iframe>
	</div>
</template>
<script>
import { Toast } from 'vant';
import tool from '../../../kits/Tools.js';
	export default {
		data(){
			return {
				
			}
		},
		props:['resuouce']
	}
</script>

<style scoped>
#Store {
	width: 100% !important;
	overflow-x: auto;
}

#iframe {
	width: 100% !important;
	border: none;
	height: 100%;
	overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// Store.vue?ce2b2f58